import type { Routes } from '../../shares/types';
import { AbbrBasic } from './basic';

export const ABBR_ROUTES: Routes = {
	abbr: {
		basic: AbbrBasic,
	},
};
